import LinearProgress from '@mui/material/LinearProgress';
import { useAuth } from 'react-oidc-context';
import { Navigate, useLocation } from 'react-router-dom';

const AuthCallback = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get('error');
  const redirectUrl = sessionStorage.getItem('authRedirectUrl') || '/builder';

  return isAuthenticated || error === 'access_denied' ? <Navigate to={redirectUrl} replace /> : <LinearProgress />;
};

export default AuthCallback;
